/**
 * @generated SignedSource<<4905d9622522781995df1cf64c179ff2>>
 * @relayHash bc100fc4a7f97e7be7598a807cfcb2cc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 38fb6023b8b77153e4d99c2e1236769d9fa74fc68da4133c7d44a8c0fb2121ac

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { BoardFilterRefinementQuery } from './BoardFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<BoardFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "38fb6023b8b77153e4d99c2e1236769d9fa74fc68da4133c7d44a8c0fb2121ac",
    "metadata": {},
    "name": "BoardFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
